import { createRouter, createWebHistory } from 'vue-router'
import Layout from '@/layout/index.vue'
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/login/index.vue'),
      meta: {
        hidden: true,
        title: '登录',
        noTagsView: true
      }
    },
    {
      path: '/',
      name: 'Root',
      component: Layout,
      redirect: '/dashboard',
      meta: { title: 'Dashboard', icon: 'HomeFilled' },
      children: [{
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index.vue'),
        meta: { hidden: true,title: 'Dashboard', icon: 'HomeFilled' }
      }]
    },
    {
      path: '/order',
      name: 'Order',
      component: Layout,
      redirect: '/order/orderList',
      meta: {
        title: '订单管理',
        icon: 'List'
      },
      children: [
        {
          path: '/order/orderList',
          name: 'orderList',
          component: () => import('@/views/order/orderList.vue'),
          meta: {
            title: '订单列表',
            icon: 'List'
          }
        },
        {
          path: '/order/orderInfo/:id(\\d+)',
          name: 'orderInfo',
          component: () => import('@/views/order/orderInfo.vue'),
          meta: {
            hidden: true,
            title: '订单详情'
          }
        }
      ]
    },
    {
      path: '/user',
      name: 'User',
      component: Layout,
      redirect: '/user/userList',
      meta: {
        title: '用户管理',
        icon: 'Avatar'
      },
      children: [
        {
          path: '/user/userList',
          name: 'userList',
          component: () => import('@/views/user/userList.vue'),
          meta: {
            title: '用户列表',
            icon: 'Avatar'
          }
        },
        {
          path: '/user/userLog',
          name: 'userLog',
          component: () => import('@/views/user/userLog.vue'),
          meta: {
            title: '用户日志',
            icon: 'Compass'
          }
        },
        {
          path: '/user/userInfo/:id(\\d+)',
          name: 'userInfo',
          component: () => import('@/views/user/userInfo.vue'),
          meta: {
            hidden: true,
            title: '用户列表'
          }
        },
        {
          path: '/user/changePwd',
          name: 'changePwd',
          component: () => import('@/views/user/changePwd.vue'),
          meta: {
            hidden: true,
            title: '修改密码'
          }
        }
      ]
    },
    {
      path: '/mch',
      name: 'Mch',
      component: Layout,
      redirect: '/mch/postRule',
      meta: {
        title: '参数设置',
        icon: 'Tools'
      },
      children: [
        {
          path: '/mch/postRule',
          name: 'postRule',
          component: () => import('@/views/mch/postRule.vue'),
          meta: {
            title: '配送规则',
            icon: 'Guide'
          }
        },
        {
          path: '/mch/carouselImage',
          name: 'carouselImage',
          component: () => import('@/views/mch/carouselImage.vue'),
          meta: {
            title: '轮播图片',
            icon: 'Picture'
          }
        },
        {
          path: '/mch/articleCate',
          name: 'newsCate',
          component: () => import('@/views/mch/articleCate.vue'),
          meta: {
            title: '新闻分类',
            icon: 'Collection'
          }
        },
        {
          path: '/mch/articleList',
          name: 'newsList',
          component: () => import('@/views/mch/articleList.vue'),
          meta: {
            title: '新闻管理',
            icon: 'Document'
          }
        },
        {
          path: '/mch/editArticle/:id*',
          name: 'editArticle',
          component: () => import('@/views/mch/editArticle.vue'),
          meta: {
            title: '编辑新闻',
            hidden: true
          }
        },
        {
          path: '/mch/config',
          name: 'config',
          component: () => import('@/views/mch/config.vue'),
          meta: {
            title: '配置信息',
            icon: 'setUp'
          }
        }
      ]
    },
    // {
    //   path: '/goods',
    //   component: Layout,
    //   redirect: '/goods/goodsList',
    //   name: 'goods',
    //   meta: {
    //     title: '商品管理',
    //     icon: 'GoodsFilled'
    //   },
    //   children: [
    //     {
    //       path: '/goods/goodsList',
    //       name: 'goodsList',
    //       component: () => import('@/views/goods/goodsList.vue'),
    //       meta: {
    //         title: '商品列表',
    //         icon: 'GoodsFilled'
    //       }
    //     },
    //     {
    //       path: '/goods/editGoods/:id(\\d+)',
    //       name: 'editGoods',
    //       component: () => import('@/views/goods/editGoods.vue'),
    //       meta: {
    //         title: '添加商品',
    //         hidden: true
    //       }
    //     },
    //     {
    //       path: '/goods/cateList',
    //       name: 'cateList',
    //       component: () => import('@/views/goods/cateList.vue'),
    //       meta: {
    //         title: '商品分类',
    //         icon: 'Grid'
    //       }
    //     },
    //     {
    //       path: '/goods/attrList',
    //       name: 'attrList',
    //       component: () => import('@/views/goods/attrList.vue'),
    //       meta: {
    //         title: '商品属性',
    //         icon:'HelpFilled'
    //       }
    //     }
    //   ]
    // },
    // {
    //   path: '/prem',
    //   name: 'Perm',
    //   component: Layout,
    //   redirect: '/prem/userRole',
    //   meta: {
    //     title: '权限管理',
    //     icon: 'UserFilled'
    //   },
    //   children: [
    //     {
    //       path: '/prem/userRole',
    //       name: 'userRole',
    //       component: () => import('@/views/perm/userRole.vue'),
    //       meta: {
    //         title: '用户角色',
    //         icon: 'UserFilled'
    //       }
    //     },
    //     {
    //       path: '/perm/menuList',
    //       name: 'menuList',
    //       component: () => import('@/views/perm/menuList.vue'),
    //       meta: {
    //         title: '系统菜单',
    //         icon: 'Menu'
    //       }
    //     },
    //     {
    //       path: '/perm/roleList',
    //       name: 'roleList',
    //       component: () => import('@/views/perm/roleList.vue'),
    //       meta: {
    //         title: '角色权限',
    //         icon: 'Setting'
    //       }
    //     }
    //   ]
    // },
    // {
    //   path: '/About',
    //   name: 'About',
    //   component: Layout,
    //   meta: { title: '关于', icon: 'HomeFilled' },
    //   children: [
    //     {
    //       path: '/AboutGo',
    //       redirect: 'https://element-plus-admin-doc.cn/',
    //       name: 'DocumentLink',
    //       meta: {
    //         title: 'DocumentLink',
    //         icon: ''
    //       }
    //     }
    //   ]
    // },
  ],
})

export default router
